import EventEmitter from 'eventemitter3'
import gsap from 'gsap/gsap-core'

class Loading extends EventEmitter
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Loading
	// ---------------------------------------------------------------------------------------------------------

  constructor(APP){
    super()

    //変数
    this.app = APP
    this.isLoaded = false
    this.total = 0
    this.loaded = 0
    this.opPer = 0
    this.currentPer = 0

    //DOM参照
    this.wave = $('.loading__wave >span')
    this.hoppy = $('.loading__hoppy')
    this.cover = $('.loading__cover')

    //背景画像読み込み対象のクラス
    const bgImageClass = ['.slide-item__bg', '.films-item__photo-cover >span', '.contents-item__photo-cover >span', '.detail-mv__bg-pic', '.js-bg-img']

    //ハンドリングメソッド
    this._onLoad = this.onLoad.bind(this)
    this._onError = this.onError.bind(this)

    //ローディング用パーツの読み込み
    const holder = this
    this.loadingAssetsNum = $('.js-loading-assets').length
    $('.js-loading-assets').each(function(index){
      const url = $(this).css('background-image').slice(5, -2)
      const img = new Image()
      img.src = url
      img.onload = (e)=>{
        if(--holder.loadingAssetsNum<=0)
        {
          holder.loadingStart()
        }
      }
    })

    //背景画像読み込み
    for(let i=0; i<bgImageClass.length; i++)
    {
      const tag = bgImageClass[i]
      $(bgImageClass[i]).each(function(index){
        holder.total ++;
        const url = $(this).css('background-image').slice(5, -2)
        const img = new Image()
        img.onload = holder._onLoad
        img.onerror = holder._onError
        img.src = url
      })
    }

    //<img>の読み込み
    $('img:not(.lazyload)').each(function(){
      holder.total ++;
      const url = $(this).attr('src')
      const img = new Image()
      img.onload = holder._onLoad
      img.onerror = holder._onError
      img.src = url
    })

    // console.log('this.total:' + this.total)
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	ローディング開始
	// ---------------------------------------------------------------------------------------------------------

  loadingStart()
  {
    //カバーをフェードアウト
    gsap.to(this.cover, 0.1, {alpha:0, ease:'none'})

    //傾ける
    gsap.to(this.hoppy, 1.0, {
      rotation:130,
      delay:0.5,
      ease:"power2.inOut",
      onStart:()=>{
        this.loop()
      }
    })
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	Loading
	// ---------------------------------------------------------------------------------------------------------

  onComplete()
  {

  }

  onLoad(e)
  {
    // console.log(e)
    // console.log($(e.target).attr('src'))

    this.loaded ++
    this.progress()
  }

  onError(e)
  {
    console.log('画像読み込み失敗：' + $(e.target).attr('src'))

    this.loaded ++
    this.progress()
  }

  progress()
  {
    // console.log(this.loaded + '/' + this.total)
    this.opPer = this.loaded / this.total

    if (this.opPer === 1) {
      this.app.onLoad();
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ループ処理
	// ---------------------------------------------------------------------------------------------------------

  loop()
  {
    //パーセント増加
    let perProgress = (this.opPer - this.currentPer) / 10
    if(perProgress > 0.01) perProgress = 0.01
    this.currentPer += perProgress
    if(this.currentPer > 0.999) this.currentPer = 1

    //波を減らす
    gsap.set(this.wave, {y:125 * this.currentPer})

    //繰り返し
    if(this.currentPer < 1 && !this.isLoaded)
    {
      requestAnimationFrame( () => {this.loop()})
    }
  }  

  // ---------------------------------------------------------------------------------------------------------
	// --	FINISH
	// ---------------------------------------------------------------------------------------------------------

  hide()
  {
    const loading = $('.loading')

    gsap.to(loading, 0.2, {
      alpha:0,
      ease:'none',
      onComplete:()=>{
        this.isLoaded = true
        loading.remove()
      }
    })
  }

	// ---------------------------------------------------------------------------------------------------------
}

export default Loading